// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerText {
  color: #003399;
  font-size: 15px;
  white-space: pre-wrap;
}

.subText {
  font-size: 11px;
  white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/common/textblock.document.header.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB","sourcesContent":[".headerText {\n  color: #003399;\n  font-size: 15px;\n  white-space: pre-wrap;\n}\n\n.subText {\n  font-size: 11px;\n  white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
